import { render, staticRenderFns } from "./EventAttendeesModal.vue?vue&type=template&id=21655acb&"
import script from "./EventAttendeesModal.vue?vue&type=script&lang=js&"
export * from "./EventAttendeesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EventAttendeesModal.vue"
export default component.exports